import { loadState as i } from "@nextcloud/initial-state";
function e() {
  try {
    return i("core", "capabilities");
  } catch {
    return console.debug("Could not find capabilities initial state fall back to _oc_capabilities"), "_oc_capabilities" in window ? window._oc_capabilities : {};
  }
}
export {
  e as getCapabilities
};
